import React from "react";
import styles from "./TextArea.module.scss";

type TextAreaProps = {
  lable: string;
  value: string;
};

export const TextArea = ({ lable, value }: TextAreaProps) => {
  return (
    <div>
      <label htmlFor={lable} className={styles.labels}>
        {lable}
      </label>
      {/* <div className={styles.contBoxes}> */}
      <div className={styles.inputContainer}>
        <textarea
          id={lable}
          className={`${styles.basicInputs}`}
          value={value}
        />
      </div>
    </div>
    // </div>
  );
};
